import { AlertIcon } from '@approvalmax/ui';
import { Alert, Fade, Grid, Table } from '@approvalmax/ui/src/components';
import { useCallback, useMemo } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { z } from 'zod';

import { getFullName } from '../../../../personsBasic/resources/components/PersonsTable/PersonsTable.helpers';
import { schema } from '../../../resources/schema';
import { columns } from './VerificationTable.constants';

export const VerificationTable = () => {
    const { control, formState } = useFormContext<z.infer<typeof schema>>();
    const { field, fieldState } = useController({ name: 'people.persons', control });

    const handleOpenDetailsPopup = useCallback<(person: (typeof field.value)[number]) => void>((person) => {
        alert(person.personId);
    }, []);

    const normalizedData = useMemo(
        () =>
            (field.value ?? []).map((person) => ({
                id: person.personId,
                name: getFullName(person),
                onOpenDetailsPopup: () => handleOpenDetailsPopup(person),
                ...person,
            })),
        [field.value, handleOpenDetailsPopup]
    );

    return (
        <Grid gap={8}>
            <Table
                hoverable={false}
                qa='persons-verification'
                progress={formState.disabled}
                progressRowCount={3}
                columns={columns}
                data={normalizedData}
            />

            <Fade in={Boolean(fieldState.error?.message)}>
                <Alert
                    data-qa='validation-error'
                    alignItems='center'
                    color='red20'
                    size='small'
                    startIcon={<AlertIcon />}
                >
                    {fieldState.error?.message}
                </Alert>
            </Fade>
        </Grid>
    );
};

VerificationTable.displayName = 'VerificationTable';
